import React, { Suspense } from 'react';
import LoadingScreen from '../LoadingScreen';

const MpSuspense: React.FC = ({ children }) => (
  <Suspense fallback={<LoadingScreen />}>{children}</Suspense>
);

export default MpSuspense;
